export const ZIPCODES_WADDENEILANDEN = [
  1790, 1791, 1792, 1793, 1794, 1795, 1796, 1797,
  8880, 8881, 8882, 8883, 8884, 8885, 8886, 8887, 8888, 8889,
  8890, 8891, 8892, 8893, 8894, 8895, 8896, 8897, 8899,
  9161, 9162, 9163, 9164, 9166,
];
/**
 * Bezorging gaat vanaf oktober 2026 dinsdag t/m zaterdag via SooCool en op maandag via Trunkrs -
 * dezelfde regels als het Vleescentrum (besluit 2026-10-07, zie planning/soocool-koppeling.md in de
 * Vleescentrum-werkmap). Een tarief voor elk adres en elk land.
 *
 * Vervangt de oude staffels: EUR 8,95, EUR 5,95 vanaf EUR 100, en de zaterdagtoeslag van
 * EUR 9,99 / 4,99.
 */
export const SEND_COST = 9.95;

/** Vanaf dit orderbedrag (productwaarde, zonder cadeaubonnen) is bezorgen gratis. */
export const FREE_DELIVERY_FROM_PRICE = 150;

/**
 * Tot hoe laat een bestelling nog meegaat met de ophaalronde van SooCool van dezelfde dag.
 * SooCool haalt maandag t/m vrijdag na 15:00 op en bezorgt de dag erna; 12:00 is de marge om te
 * snijden en in te pakken.
 */
export const ORDER_CUTOFF_HOUR = 12;

/** De cut-off hangt aan de Nederlandse klok, niet aan die van de bezoeker. */
export const DELIVERY_TIME_ZONE = "Europe/Amsterdam";

export const CURRENCY = "€ ";
export const CURRENCY_CODE = "EUR";
export const DELIVERY_OPTIONS = {
  PICKUP: "pickup",
  SEND: "send",
};

export const PAYMENT_METHODS = {
  CREDITCARD: "creditcard",
  IDEAL: "ideal",
  BANCONTACT: "bancontact",
};

export const ADDRESS_TYPES = {
  DELIVERY: "DELIVERY",
  INVOICE: "INVOICE",
};
export const PICKUP_TIME_FROM = "13:00";
export const PICKUP_TIME_UNTIL = "16:00";
export const PICKUP_TIME_FROM_SATURDAY = "11:00";
export const PICKUP_TIME_UNTIL_SATURDAY = "15:00";
export const DELIVERY_DATE_WARNING_DAYS = 28;

/* -------------------------------------------------------------------------- *
 * BELGIE - waar SooCool wel en niet komt
 * -------------------------------------------------------------------------- */

/**
 * De Belgische postcodegebieden die SooCool bedient (artikel 5 van de overeenkomst): Brussel en
 * Vlaanderen, en daar uitsluitend in het dagvenster 08:00-18:00. Beide grenzen zijn inclusief.
 * Op maandag rijdt Trunkrs; het postcodegebied blijft voor de eenvoud hetzelfde.
 */
export const BE_DELIVERY_ZIP_RANGES = [
  { from: 1000, to: 1299 },
  { from: 1500, to: 3999 },
  { from: 8000, to: 9999 },
];

/* -------------------------------------------------------------------------- *
 * LEVERVENSTERS - de vijf tijdvakken uit artikel 5 van de SooCool-overeenkomst
 * -------------------------------------------------------------------------- */

/**
 * De vijf vensters die SooCool rijdt, en de enige vijf waar de klant uit kan kiezen. Dit is een
 * GESLOTEN set: `api` zet het gekozen label rechtstreeks om in het `timeWindow` van de SooCool-order.
 *
 * - `label` - de tekst zoals hij in het contract staat; gaat als `delivery.timeSlot` naar Firestore.
 *   ASCII: een koppelteken, geen spaties.
 * - `nameKey` - vertaalsleutel voor de naam die de klant leest.
 * - `surcharge` - of dit venster `NARROW_TIMESLOT_SURCHARGE` kost (EUR 15 i.p.v. EUR 14 per stop).
 * - `belgium` - of het venster in Belgie kan (SooCool: alleen het dagvenster).
 * - `saturday` - of het venster op zaterdag kan (SooCool: geen avond op zaterdag).
 * - `monday` - of het venster op maandag kan. Maandag rijdt Trunkrs, en Trunkrs bezorgt alleen 's
 *   avonds; de twee SooCool-vlaggen gelden die dag niet.
 */
export const DELIVERY_TIME_SLOTS = [
  {
    label: "08:00-18:00",
    nameKey: "delivery_timeslot.day",
    startTime: "08:00",
    endTime: "18:00",
    surcharge: false,
    belgium: true,
    saturday: true,
    monday: false,
  },
  {
    label: "08:00-22:00",
    nameKey: "delivery_timeslot.day_extended",
    startTime: "08:00",
    endTime: "22:00",
    surcharge: false,
    belgium: false,
    saturday: true,
    monday: false,
  },
  {
    label: "08:00-12:00",
    nameKey: "delivery_timeslot.morning",
    startTime: "08:00",
    endTime: "12:00",
    surcharge: true,
    belgium: false,
    saturday: true,
    monday: false,
  },
  {
    label: "12:00-17:00",
    nameKey: "delivery_timeslot.afternoon",
    startTime: "12:00",
    endTime: "17:00",
    surcharge: true,
    belgium: false,
    saturday: true,
    monday: false,
  },
  {
    label: "17:00-22:00",
    nameKey: "delivery_timeslot.evening",
    startTime: "17:00",
    endTime: "22:00",
    surcharge: false,
    belgium: false,
    saturday: false,
    monday: true,
  },
];

/**
 * Het venster waar de checkout mee begint, en waar hij op terugvalt bij een datum of land waarop de
 * keuze niet kan: 08:00-18:00 kan op elke SooCool-dag, overal, zonder toeslag. Op maandag valt het
 * weg - dan wordt het de avond (zie `resolveDeliveryTimeSlot`).
 */
export const DEFAULT_DELIVERY_TIME_SLOT = DELIVERY_TIME_SLOTS[0].label;

/**
 * Maandag is de Trunkrs-dag: alleen 17:00-22:00, bestellen tot en met zondag 23:59, en een daglimiet
 * die `api` op elke maandag zet. Afgeleid van de `monday`-vlag, zodat tekst en keuze gelijk blijven.
 */
export const MONDAY_DELIVERY_TIME_SLOT = DELIVERY_TIME_SLOTS.find(
  (slot) => slot.monday,
);

/**
 * De toeslag in euro's INCLUSIEF btw voor een van de twee smalle vensters. Komt BOVENOP het tarief en
 * vervalt NIET boven de gratis-drempel: hij hoort bij het venster, niet bij het orderbedrag.
 */
export const NARROW_TIMESLOT_SURCHARGE = 1.25;

/** Het venster bij een contractlabel, of null als het label niet in de gesloten set zit. */
export const findDeliveryTimeSlot = (label) =>
  DELIVERY_TIME_SLOTS.find((slot) => slot.label === label) || null;

/** De toeslag bij een venster; 0 voor een breed of onbekend venster. */
export const getDeliveryTimeSlotSurcharge = (label) =>
  findDeliveryTimeSlot(label)?.surcharge ? NARROW_TIMESLOT_SURCHARGE : 0;
